module.exports = __webpack_public_path__ + "static/media/224-2244409_forward-arrow-icon-share-arrow-png.ce71dc40.png";